<template>
	<div>
		<el-button @click="newD=true" type="primary">新建分销组</el-button>
		<el-table :data="tableData" :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}">
			<el-table-column prop="name" label="分组名称"></el-table-column>
			<el-table-column prop="addTime" label="创建时间"></el-table-column>
			<el-table-column label="分销奖励">
				<template slot-scope="scope">
					{{scope.row.type==0? (scope.row.rate*100).toFixed(2)+'%' : scope.row.money/100 +"元"}}
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button @click="dialog=true" type="text">查看成员</el-button>
					<el-button @click="detail(scope.row.id);newD=true;" type="text">编辑</el-button>
					<el-button type="text" style="color: red;margin-left: 20px;">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 新建分组弹窗 -->
		<el-dialog :visible.sync="newD" title="新建分组" width="500px">
			<el-form>
				<el-form-item label="分组名">
					<el-input v-model="sendData.name" style="width: 200px;"></el-input>
				</el-form-item>
				<el-form-item label="分销者获得金额">
					<el-radio-group v-model="sendData.type">
						<el-radio :label="0">按比例</el-radio>
						<el-radio :label="1">按固定金额</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item v-if="sendData.type==1" label="分销者获得金额">
					<el-input-number v-model="sendData.money" size="small" :precision="2" :step="0.01"
						style="width: 200px;"></el-input-number>元
				</el-form-item>
				<el-form-item v-else label="分销者获得金额比例">
					<el-input v-model="sendData.rate" style="width: 200px;"></el-input>%
				</el-form-item>
				<el-form-item label="背景图">
					<!-- <div> -->
					<upload v-model="sendData.img"  class="el-tabs-pane-upload"  ref="sss"
						style="width: 300px; height: 300px;" />
					<p style="margin-top: 30px;font-size: 14px;color: #808080;">点击上传详情页图片</p>
					<!-- </div> -->
				</el-form-item>
				<el-form-item label="分销券">
					<el-tag :key="tag.id" v-for="tag in couponAdd" closable @close="handleClose(tag)"
						style="margin-left: 5px;">{{tag.title}}</el-tag>
					<el-button type="text" size="small" @click="dialog_quan=true"
						style="color:#999; border:2px dashed; width:100px;margin-left: 10px;">
						<i class="el-icon-plus"></i>选择券
					</el-button>
				</el-form-item>
			</el-form>
			<div>
				<el-button @click="">取消</el-button>
				<el-button @click="saveGroup" type="primary">保存</el-button>
			</div>
		</el-dialog>
		<!-- 分销成员弹窗 -->
		<el-dialog :visible.sync="dialog" title="分销成员">
			<el-table :data="manTable" :cell-style="{'text-align':'center'}"
				:header-cell-style="{'text-align':'center'}">
				<el-table-column label="昵称">
					<template slot-scope="scope">
						{{scope.row.nickName}}
					</template>
				</el-table-column>
				<el-table-column prop="code" label="分销码"></el-table-column>
				<el-table-column label="手机号">
					<template slot-scope="scope">
						{{scope.row.telphone}}
					</template>
				</el-table-column>
			</el-table>
			<div class="pagescg">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="query.pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="10"
					layout="total, sizes, prev, pager, next, jumper" :total="query.total">
				</el-pagination>
			</div>
		</el-dialog>
		<!-- 分销优惠券弹窗 -->
		<el-dialog :visible.sync="dialog_quan" width="60%">
			<div class="title" style="margin-top:-10px;">
				<div class="blue"></div>
				<div style="flex: 1; font-size: 18px;">选择优惠券</div>
				<span style="float: right; margin-bottom: 10px;">
					<el-button @click="dialog_quan = false">取 消</el-button>
					<el-button type="primary" @click="saveSelect()">确 定</el-button>
				</span>
			</div>
			<div>
				<el-table :cell-style="{'text-align':'center'}"
					:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
					:data="couponList" tooltip-effect="dark" @selection-change="handleSelectionChange"
					style="width: 100%">
					<el-table-column type="selection"></el-table-column>
					<el-table-column prop="id" label="券ID"></el-table-column>
					<el-table-column align="center" prop="title" label="名称"></el-table-column>
					<el-table-column prop="couponType" label="类型"></el-table-column>
					<el-table-column prop="storeNames" label="适用范围"></el-table-column>
					<el-table-column prop="termOfValidity" label="有效期"></el-table-column>
					<el-table-column prop="getNumScaleTotalNum" label="已领取/优惠券总量"></el-table-column>
					<el-table-column prop="useNum" label="已使用"></el-table-column>
				</el-table>
				<div class="pagescg">
					<el-pagination @size-change="handleSizeChangeCoupon" @current-change="handleCurrentChangeCoupon"
						:current-page="filter.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
						layout="total, sizes, prev, pager, next, jumper" :total="filter.total">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import util from './util'
	import upload from "../../compents/upload/upload";
	export default {
		components: {
			upload
		},
		data() {
			return {
				tableData: [{
					name: '1',
					time: '2021-10-08',
					scale: '10%'
				}],
				sendData: {
					type: 0,
					img: ''
				},
				manTable: [], //分销成员表格数据
				dialog: false,
				newD: false,
				dialog_quan: false,
				dialog_quan_second: false,
				couponList: [],
				couponAdd: [],
				query: {
					pageNum: 1,
					size: 10,
					total: 100
				},
				filter: {
					pageNum: 1,
					pageSize: 10,
					total: 100
				},
			}
		},
		mounted() {
			this.getList()
			this.getCoupon()
			this.getMember()
		},
		methods: {
			getList() {
				this.$http.get("dDistGroup/list").then(res => {
					this.tableData = res.body.data
					console.log(11111)
				})
			},
			getCoupon() {
				this.$http.get("dCoupon/list" + "?pageNum=" + this.filter.pageNum + "&pageSize=" + this.filter.pageSize)
					.then(res => {
						this.couponList = res.body.data;
						this.filter.total = res.body.total;
					})
			},
			saveGroup(id) {
				var s = this.sendData
				var tmp = []
				this.couponAdd.forEach(item => {
					tmp.push(item.id)
				})
				var ids = tmp.join(",")
				if (s.type == 0) { //按比例分佣
					s.money = 0
				} else { //按固定金额分佣
					s.rate = 0
				}
				var a = {
					id: this.sendData.id,
					name: s.name,
					couponId: ids,
					rate: s.rate / 100,
					money: (s.money * 100).toFixed(0),
					type: s.type,
					img: s.img
				}
				this.$http.post("dDistGroup/save", JSON.stringify(a)).then(res => {
					if (res.body.code == 200) {
						this.$message.success('保存成功');
						this.newD = false
						this.getList()
						util.$emit('test', 'test')
					}
				})
			},
			detail(id) {
				this.$http.get("dDistGroup/detail?id=" + id).then(res => {
					var tmp = []
					this.sendData = res.body.data
					this.couponAdd = this.sendData.couponId
					if (this.sendData.money != null && this.sendData.money != "") {
						this.sendData.money = this.sendData.money / 100
					}
					if (this.sendData.rate != null && this.sendData.rate != "") {
						this.sendData.rate = this.sendData.rate * 100
					}
					var c = []
					c = this.couponAdd.split(",")
					c.forEach(item => {
						this.couponList.forEach(coupon => {
							if (item == coupon.id) {
								tmp.push(coupon)
							}
						})
					})
					this.couponAdd = tmp
					// this.toggleSelection(this.couponAdd)
				})
			},
			getMember() {
				var a = "?pageNum=" + parseInt(this.query.pageNum - 1) + "&pageSize=" + this.query.size
				this.$http.get("dDistUser/list" + a).then(res => {
					this.manTable = res.body.data
					this.query.total = res.body.total
				})
			},
			saveSelect() {
				this.dialog_quan = false
			},
			//点详情选择表格
			toggleSelection(rows) {
				console.log(rows)
				rows.forEach(row => {
					this.$nextTick().then(function() {
						this.$refs.multipleTable.toggleRowSelection(row, true);
					})
				});
			},
			// 删除tag
			handleClose(tag) {
				this.couponAdd.splice(this.couponAdd.indexOf(tag), 1);
				this.$refs.multipleTable.toggleRowSelection(tag);
				console.log(this.couponAdd)
			},
			// 优惠券表格选择
			handleSelectionChange(val) {
				this.couponAdd = val
			},
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.getMember();
			},
			handleCurrentChange(val) {
				this.query.pageNum = val;
				this.getMember();
			},
			handleSizeChangeCoupon(val) {
				this.filter.pageSize = val;
				this.getCoupon();
			},
			handleCurrentChangeCoupon(val) {
				this.filter.pageNum = val;
				this.getCoupon();
			},
			closeC(id) {
				this.$nextTick(() => {
					if (id === 1) {
						this.sendData.firstCouponId = undefined
					} else {
						this.sendData.secondCouponId = undefined
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.pagescg {
		text-align: center;
	}
</style>